import { addDoorsToCores } from "./index25.js";
import { addDoorsToEntrances } from "./index26.js";
import { addDoorsToTechnicalSpaces } from "./index27.js";
import { addEntranceOpeningsToCorridors } from "./index28.js";
import { addExitDoorsToCores } from "./index29.js";
import { addOpeningsBetweenCorridors } from "./index30.js";
import { addFireDoorsToCorridors } from "./index113.js";
import { isBuildingSprinklered } from "./index118.js";
import { getActiveBuildings } from "./index183.js";
const pipeAddOpenings = ([parent, { buildingIds, aggProps }]) => {
  const dataset = aggProps.dataset;
  const buildings = getActiveBuildings(parent, aggProps);
  const aggConfig = dataset.aggConfig;
  for (const building of buildings) {
    if (buildingIds && !buildingIds.includes(building.uuid))
      continue;
    addDoorsToEntrances({ building, dataset });
    addExitDoorsToCores({ building, dataset });
    addDoorsToCores({ building, dataset });
    addDoorsToTechnicalSpaces({ building, dataset });
    addOpeningsBetweenCorridors(building);
    addEntranceOpeningsToCorridors(building);
    addFireDoorsToCorridors({
      building,
      dataset,
      isSprinklered: isBuildingSprinklered(building, aggConfig)
    });
  }
  return [parent, void 0];
};
export {
  pipeAddOpenings
};
//# sourceMappingURL=index91.js.map
